import { render, staticRenderFns } from "./AdminProjects.vue?vue&type=template&id=22552da6&scoped=true&"
import script from "./AdminProjects.vue?vue&type=script&lang=js&"
export * from "./AdminProjects.vue?vue&type=script&lang=js&"
import style0 from "./AdminProjects.vue?vue&type=style&index=0&id=22552da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22552da6",
  null
  
)

component.options.__file = "www/vues/admin/AdminProjects.vue"
export default component.exports